export enum OrderItemProductNonDoableFlag {
  MissingAssets = "MissingAssets",
  CandidateAssets = "CandidateAssets",
  Unknown = "Unknown",
}
